import React from 'react';
import { useFormContext } from 'react-hook-form';

import { type SupplierFormData } from '../../../types';
import {
  fromFieldKey,
  NO_CATALOG,
  SHOW_ALL_PRODUCTS_KEY,
  toFieldKey,
} from '../utils/defaultCatalogValue';

import { CustomCatalogPicker } from './CustomCatalogPicker';

const FIXED_OPTIONS = [
  { key: SHOW_ALL_PRODUCTS_KEY, label: 'Show all products' },
  { key: NO_CATALOG, label: 'Hide all products' },
];

interface DefaultCatalogFieldProps {
  vendorId: string;
}

/** The catalog a distributor's chats start from, unless a chat overrides it. */
export const DefaultCatalogField: React.FC<DefaultCatalogFieldProps> = ({
  vendorId,
}) => {
  const {
    watch,
    setValue,
    formState: { errors },
  } = useFormContext<SupplierFormData>();

  const storedValue = watch('supplierDefaultSubCatalog');

  return (
    <CustomCatalogPicker
      vendorId={vendorId}
      label="Default catalog"
      testId="supplier-default-catalog-field"
      fixedOptions={FIXED_OPTIONS}
      value={toFieldKey(storedValue)}
      description="This default can be overwritten for each chat separately."
      errorMessage={errors.supplierDefaultSubCatalog?.message}
      onChange={(key) =>
        setValue('supplierDefaultSubCatalog', fromFieldKey(key), {
          shouldDirty: true,
          shouldValidate: true,
        })
      }
    />
  );
};
